import { Button } from "@/components/ui/button";
import { CardContent } from "@/components/ui/card";
import { Label } from "@/components/ui/label";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";

const PaymentInformationStep = ({ oop, onNext, selectedMethod, onMethodChange }) => {
   return (
      <div data-testid="payment-information-step" className="flex flex-col p-6 rounded-lg shadow-lg bg-white dark:bg-black w-full max-w-2xl mx-auto">
         <div className="mb-4">
            <h2 className="text-[25px] font-bold text-green-700 dark:text-green-500 text-center">Payment Information</h2>
         </div>
         <CardContent className="space-y-6">
            <div className="text-center">
               <h2 className="text-2xl font-semibold text-gray-900 dark:text-gray-100">
                  ₱ {oop?.totalAmount?.toFixed(2)}
               </h2>
               <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">Amount to Pay</p>
            </div>

            <div className="space-y-4">
               <div className="bg-gray-50 dark:bg-gray-800 p-4 rounded-lg border border-gray-100 dark:border-gray-700">
                  <h3 className="font-medium text-gray-900 dark:text-gray-100">Order Details</h3>
                  <div className="mt-2 space-y-2">
                     <div className="flex justify-between text-sm">
                        <span className="text-gray-500 dark:text-gray-400">Bill Number:</span>
                        <span className="text-gray-900 dark:text-gray-100">{oop?.billNo}</span>
                     </div>
                     <div className="flex justify-between text-sm">
                        <span className="text-gray-500 dark:text-gray-400">Application Number:</span>
                        <span className="text-gray-900 dark:text-gray-100">{oop?.applicationNumber}</span>
                     </div>
                  </div>
               </div>

               <div className="bg-gray-50 dark:bg-gray-800 p-4 rounded-lg border border-gray-100 dark:border-gray-700">
                  <h3 className="font-medium text-gray-900 dark:text-gray-100 mb-4">Select Payment Method</h3>
                  <RadioGroup
                     value={selectedMethod}
                     onValueChange={onMethodChange}
                     className="gap-4"
                  >
                     <div className="flex items-center space-x-2 border dark:border-gray-700 p-4 rounded-lg opacity-50 cursor-not-allowed bg-white dark:bg-gray-800">
                        <RadioGroupItem value="GCASH" id="gcash" disabled />
                        <Label htmlFor="gcash" className="flex-1">
                           <div className="font-medium text-gray-400 dark:text-gray-500">GCash</div>
                           <div className="text-sm text-gray-400 dark:text-gray-500">Pay online using GCash</div>
                        </Label>
                     </div>
                     <div className="flex items-center space-x-2 border dark:border-gray-700 p-4 rounded-lg bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700/50 transition-colors">
                        <RadioGroupItem value="MANUAL" id="manual" />
                        <Label htmlFor="manual" className="flex-1">
                           <div className="font-medium text-gray-900 dark:text-gray-100">Manual Payment</div>
                           <div className="text-sm text-gray-500 dark:text-gray-400">Pay at DENR Office</div>
                        </Label>
                     </div>
                  </RadioGroup>
               </div>
            </div>

            <div className="flex justify-end pt-4">
               <Button
                  data-testid="next-button"
                  onClick={onNext}
                  disabled={!selectedMethod}
                  className="w-full bg-gradient-to-r from-green-600 to-green-700 hover:from-green-700 hover:to-green-800 text-white
                     dark:from-green-500 dark:to-green-600 dark:hover:from-green-600 dark:hover:to-green-700
                     disabled:opacity-50 disabled:cursor-not-allowed"
               >
                  Continue
               </Button>
            </div>
         </CardContent>
      </div>
   );
};

export default PaymentInformationStep;
